const actions = {
  GET_START_APP_SETTINGS_REQUEST: 'START_APP_SETTINGS_REQUEST',
  GET_START_APP_SETTINGS_ERROR: 'START_APP_SETTINGS_ERROR',
  GET_START_APP_SETTINGS_SUCCESS: 'START_APP_SETTINGS_SUCCESS',

  getStartAppSettings: () => ({
    type: actions.GET_START_APP_SETTINGS_REQUEST,
  }),

  getStartAppSettingsError: data => ({
    type: actions.GET_START_APP_SETTINGS_ERROR,
    payload: data,
  }),

  getStartAppSettingsCompleted: data => ({
    type: actions.GET_START_APP_SETTINGS_SUCCESS,
    payload: data,
  }),
};

export default actions;
